/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs */

const en_svc_full_stack_web_apps_deploy_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deployed on Vercel or your infra of choice with CI, env hygiene, previews, and rollbacks.`)
};

const ar_svc_full_stack_web_apps_deploy_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منشور على Vercel أو بنيتك المفضلة مع CI ونظافة بيئات ومعاينات والتراجع عن الإصدارات.`)
};

const bn_svc_full_stack_web_apps_deploy_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vercel বা আপনার পছন্দের ইনফ্রায় CI, এনভ হাইজিন, প্রিভিউ ও রোলব্যাকসহ ডিপ্লয়।`)
};

const de_svc_full_stack_web_apps_deploy_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereitgestellt auf Vercel oder einer Infrastruktur Ihrer Wahl mit CI, sauberer Env-Konfiguration, Vorschauen und Rollbacks.`)
};

const es_svc_full_stack_web_apps_deploy_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplegado en Vercel o la infra de su elección con CI, envs sanos, previews y rollbacks.`)
};

const fr_svc_full_stack_web_apps_deploy_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déployé sur Vercel ou l'infrastructure de votre choix avec CI, envs propres, previews et rollbacks.`)
};

const pt_svc_full_stack_web_apps_deploy_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implantado no Vercel ou na infra de sua escolha com CI, envs saudáveis, previews e rollbacks.`)
};

const zh_svc_full_stack_web_apps_deploy_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部署到 Vercel 或您选的基础设施，带 CI、环境变量管理、预览和回滚。`)
};

const tr_svc_full_stack_web_apps_deploy_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI, env hijyeni, önizlemeler ve rollback'lerle Vercel'e ya da seçtiğiniz altyapıya dağıtılır.`)
};

const ru_svc_full_stack_web_apps_deploy_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Деплой на Vercel или вашу инфру с CI, env-гигиеной, превью и откатами.`)
};

const pl_svc_full_stack_web_apps_deploy_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrożony na Vercel albo wybraną infrę z CI, higieną envów, podglądami i rollbackami.`)
};

/**
* | output |
* | --- |
* | "Deployed on Vercel or your infra of choice with CI, env hygiene, previews, and rollbacks." |
*
* @param {Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_deploy_desc6 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Deploy_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_deploy_desc6(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_deploy_desc6(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_deploy_desc6(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_deploy_desc6(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_deploy_desc6(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_deploy_desc6(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_deploy_desc6(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_deploy_desc6(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_deploy_desc6(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_deploy_desc6(inputs)
	return en_svc_full_stack_web_apps_deploy_desc6(inputs)
});
export { svc_full_stack_web_apps_deploy_desc6 as "svc_full-stack-web-apps_DEPLOY_desc" }